<template>
<kt-row>
    <kt-col xs="12" class="mb-5">
        <img :src="payman.logo" style="max-width:300px" class="d-block m-auto">
    </kt-col>

    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="farsi_name">
                {{ $t('label.farsi_name') }}
            </kt-form-label>
            <kt-form-control
                id="farsi_name"
                name="farsi_name"
                disabled
                :value="payman.farsi_name"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>
    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="english_name">
                {{ $t('label.english_name') }}
            </kt-form-label>
            <kt-form-control
                id="english_name"
                name="english_name"
                disabled
                :value="payman.english_name"
                dir="ltr"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>
    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="payman_sequence">
                {{ $t('label.gateway_id') }}
            </kt-form-label>
            <kt-form-control
                id="payman_sequence"
                name="payman_sequence"
                disabled
                :value="payman.sequence"
                dir="ltr"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>
    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="created_at">
                {{ $t('label.created_at') }}
            </kt-form-label>
            <kt-form-control
                id="created_at"
                name="created_at"
                disabled
                :value="payman.created_at"
                dir="ltr"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>

    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="subcategory_code">
                {{ $t('label.subcategory_code') }}
            </kt-form-label>
            <kt-form-control
                id="subcategory_code"
                name="subcategory_code"
                disabled
                :value="subcategory"
                class="form-control kt-selectpicker"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>
    
    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="address">
                {{ $t('label.address') }}
            </kt-form-label>
            <kt-form-control
                id="address"
                name="address"
                disabled
                :value="payman.address"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>

    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="postal_code">
                {{ $t('label.postal_code') }}
            </kt-form-label>
            <kt-form-control
                id="postal_code"
                name="postal_code"
                disabled
                :value="payman.postal_code"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>

    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="telephone">
                {{ $t('label.telephone') }}
            </kt-form-label>
            <kt-form-control
                dir="ltr"
                id="telephone"
                name="telephone"
                disabled
                :value="payman.phone_number"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>

    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="sheba_number">
                {{ $t('label.sheba_number') }}
            </kt-form-label>
            <kt-form-control
                dir="ltr"
                id="sheba_number"
                name="sheba_number"
                disabled
                :value="sheba"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>
    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="site_address">
                {{ $t('label.site_address') }}
            </kt-form-label>
            <kt-form-control
                dir="ltr"
                id="site_address"
                name="site_address"
                disabled
                :value="payman.website_address"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>

    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="server_ip">
                {{ $t('label.server_ip') }}
            </kt-form-label>
            <kt-form-control
                dir="ltr"
                id="server_ip"
                name="server_ip"
                disabled
                :value="payman.server_ip"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>
</kt-row>
</template>

<script>
import { subcategories } from '@/constants/subcategories'
import { wages } from '@/constants/wageStatus'

export default {
    props: {
        payman: {
            required: true,
        }
    },
    computed: {
        sheba() {
            return this.payman.sheba.join(',')
        },
        subcategory() {
            let subcategory = subcategories.find(subcategory => subcategory.key === this.payman.category_code)

            if(subcategory) {
                return subcategory.value
            }

            return null

        }
    }
}
</script>

<style>

</style>